package com.shreyasjoshi.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.dom.*
import com.shreyasjoshi.components.*

@Page
@Composable
fun ProjectsPage() {
    var isDarkMode by remember { mutableStateOf(true) }
    var isResumeModalOpen by remember { mutableStateOf(false) }

    Div(
        attrs = {
            classNames(
                "min-h-screen", "flex", "flex-col", "transition-colors", "duration-200",
                if (isDarkMode) "bg-[#050505] text-white" else "bg-white text-slate-900"
            )
        }
    ) {
        Navbar(
            isDarkMode = isDarkMode,
            onToggleTheme = { isDarkMode = !isDarkMode },
            onOpenResumeModal = { isResumeModalOpen = true }
        )

        Main(attrs = { classNames("flex-1", "w-full", "py-8") }) {
            ProjectsSection(isDarkMode = isDarkMode)
        }

        Footer(
            isDarkMode = isDarkMode,
            onOpenResumeModal = { isResumeModalOpen = true }
        )

        ResumeModal(
            isOpen = isResumeModalOpen,
            isDarkMode = isDarkMode,
            onClose = { isResumeModalOpen = false }
        )
    }
}



